/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import api from "../../../Component/axios";

export const useEtiqueta = (id_tipo_caja, id_tipo_etiqueta) => {
  const token = localStorage.getItem("@Token");
  const [etiquetas, setEtiquetas] = useState([]);
  const [isEtiquetaLoading, setIsEtiquetaLoading] = useState(false);

  const getEtiqueta = async () => {
    setIsEtiquetaLoading(true);
    try {
      const response = await api.get(
        `api/etiquetas/etiqueta/?id_tipo_caja=${id_tipo_caja}&id_tipo_etiqueta=${id_tipo_etiqueta}`,
        {
          headers: {
            Authorization: "Token " + token,
          },
        }
      );
      setEtiquetas(response.data);
    } catch (error) {
      setEtiquetas([]);
      console.log(error);
    } finally {
      setIsEtiquetaLoading(false);
    }
  };

  useEffect(() => {
    if (id_tipo_caja !== 0 && id_tipo_etiqueta !== 0) {
      getEtiqueta();
    } else {
      setEtiquetas([]);
    }
  }, [id_tipo_caja, id_tipo_etiqueta]);

  return { getEtiqueta, etiquetas, isEtiquetaLoading };
};
